import { Component, Input, OnInit } from '@angular/core';
import { AlarmMessage } from '../../../../alarm/alarm-message';
import { SidebarService } from '../../../../shared/sidebar/sidebar.service';
import { BaseTrain } from '../../common/train';
import { TabId } from '../../train-info/train-info/train-info.component';
import { VRGroupService } from '../../vrgroup.service';

interface DisplayedAlarm {
  tooltipText: string;
  tabId: TabId;
  technical: boolean;
  originalAlarm: AlarmMessage;
}

@Component({
  selector: 'qm-train-list-alarm-icons',
  templateUrl: './train-list-alarm-icons.component.html',
  styleUrls: ['./train-list-alarm-icons.component.scss']
})
export class TrainListAlarmIconsComponent implements OnInit {

  @Input() train: BaseTrain;
  displayedTrainAlarms: DisplayedAlarm[] = [];

  constructor(
    private vrGroupService: VRGroupService,
    private sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    if (!!this.train) {
      this.displayedTrainAlarms = this.train.alarms.map(alarmToDisplayedAlarm);
    }
  }

  public async openDetails(tabId: TabId) {
    const feature = await this.vrGroupService.getTrainMapElement(this.train.tripNumber, this.train.tripDate);
    this.sidebarService.requestSidebarPanel('ElementInfo' + this.train._id, { openTab: tabId, feature });
  }

}

const alarmToDisplayedAlarm = (alarm: AlarmMessage): DisplayedAlarm => {
  switch (alarm.metadata.type) {
    case 'trainDeparture':
      return {
        tooltipText: 'Train departure',
        tabId: 'schedule',
        technical: false,
        originalAlarm: alarm
      };
    case 'vrTrainStopped':
      return {
        tooltipText: 'Stopped',
        tabId: 'schedule',
        technical: false,
        originalAlarm: alarm
      };
    case 'vrTrainConflict':
      return {
        tooltipText: 'Equipment conflict',
        tabId: 'dependencies',
        technical: false,
        originalAlarm: alarm
      };
    case 'vrShiftConflict':
      return {
        tooltipText: 'Personnel conflict',
        tabId: 'personel',
        technical: false,
        originalAlarm: alarm
      };
    case 'vrWheelAlert':
      return {
        tooltipText: 'Wheel alert',
        tabId: 'schedule',
        technical: true,
        originalAlarm: alarm
      };
    case 'vrOverheating':
      return {
        tooltipText: 'Overheating alert',
        tabId: 'schedule',
        technical: true,
        originalAlarm: alarm
      };
    case 'vrVoltageAlert':
      return {
        tooltipText: 'Voltage alert',
        tabId: 'schedule',
        technical: true,
        originalAlarm: alarm
      };
  }
}